<template>
    <div class="animated fadeIn">
      <b-row>
          <b-col sm="12">
            <b-card header-tag="header" footer-tag="footer">
              <div slot="header">
                <strong>Performance Report KSA</strong>
              </div>
                
        <!-- code for tab -->
              <b-row>
                <b-col >
                    
                <div>
                  <ul class="nav nav-tabs nav-justified">
                    <li class="nav-item">
                      <a @click="activeTab = 1;" class="nav-link" :class="{'active' : isActiveTab(1)}" >Rider-Wise</a>
                    </li>

                    <li class="nav-item">
                      <a @click="activeTab = 2;" class="nav-link " :class="{'active' : isActiveTab(2)}">Hub-Wise</a>
                    </li>
                  </ul>
                </div>                       
                </b-col>
              </b-row>
              <component :is="currentComponent" class="mt-3"></component>
            </b-card>
          </b-col>
      </b-row>
    </div>
</template>

<script>
import hubWisePerformanceReport_KSA_new from "./hubWisePerformanceReport_new/hubWisePerformanceReport_KSA_new.vue";
import riderWisePerformanceReport_KSA_new from "./riderWisePerformanceReport_new/riderWisePerformanceReport_KSA_new.vue";

  export default{
    components: {
        hubWisePerformanceReport_KSA_new, 
        riderWisePerformanceReport_KSA_new 
    },
    data: function(){
      return{
        activeTab: 1,
        //selected_status:'Rider_Wise',
      }
    },
    computed: {
        currentComponent(){
          console.log("this.activeTab----> ",this.activeTab);
            if(this.activeTab === 1)           
              return "riderWisePerformanceReport_KSA_new";
            else            
              return "hubWisePerformanceReport_KSA_new";
        }
    },

    created: function(){
        this.isActiveTab(1);
    },

    methods: {
        isActiveTab(id)
        {
          return this.activeTab === id;
        },
    }
  }
</script>

<style>

</style>